






























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiDeNovidadesConfigurada, buscarAtualizacoes, buscarIdsLidos } from '@/api/novidades'
import type { Atualizacao, ResultadoDaBusca } from '@/shareds/novidades/modelo'
import { agruparPorAnoEMes, buscar } from '@/shareds/novidades/modelo'
import { area as coresDaArea, areasPresentes } from '@/shareds/novidades/tema'
import { estadoDaLista } from '@/shareds/novidades/navegacao'
import RaizDeNovidades from './RaizDeNovidades.vue'
import CapaDaAtualizacao from './CapaDaAtualizacao.vue'
import CartaoDaAtualizacao from './CartaoDaAtualizacao.vue'

const ESPERA_DA_BUSCA = 250

@Component({ components: { RaizDeNovidades, CapaDaAtualizacao, CartaoDaAtualizacao } })
export default class ListaDeNovidades extends Vue {
	atualizacoes: Atualizacao[] = []
	carregando = true
	erro = false
	/** null enquanto não se sabe (ou se a consulta falhou): sem selo de nova. */
	lidas: Set<string> | null = null
	busca = ''
	termo = ''
	area: string | null = null
	esperaDaBusca: ReturnType<typeof setTimeout> | null = null

	get apiConfigurada() {
		return apiDeNovidadesConfigurada()
	}

	get capa() {
		return this.atualizacoes[0]
	}

	get capaNova() {
		return !!this.lidas && !!this.capa && !this.lidas.has(this.capa.id)
	}

	get filtrando() {
		return !!this.termo.trim() || !!this.area
	}

	get areas() {
		return areasPresentes(this.atualizacoes.map(a => a.areas))
	}

	get resultados(): Record<string, ResultadoDaBusca> {
		const resultados: Record<string, ResultadoDaBusca> = {}
		for (const a of this.atualizacoes) resultados[a.id] = buscar(a, this.termo)
		return resultados
	}

	get filtradas() {
		return this.atualizacoes.filter(a =>
			(!this.area || a.areas.includes(this.area))
			&& this.resultados[a.id].encontrou
			&& (this.filtrando || a !== this.capa))
	}

	get anos() {
		return agruparPorAnoEMes(this.filtradas)
	}

	get resumoDoFiltro() {
		const n = this.filtradas.length
		const quantas = n === 1 ? '1 atualização' : `${n} atualizações`
		const partes = [this.area ? `em ${this.area}` : '', this.termo.trim() ? `com "${this.termo.trim()}"` : '']
		return [quantas, ...partes].filter(Boolean).join(' ')
	}

	get dicaSemResultado() {
		if (this.termo.trim() && this.area) return 'Tente outra palavra ou mostre todas as áreas.'
		if (this.termo.trim()) return 'Tente outra palavra, ou só uma parte dela.'
		return 'Nenhuma atualização desta área ainda.'
	}

	itensAchados(a: Atualizacao) {
		return this.termo.trim() ? this.resultados[a.id].itens : []
	}

	corDoPonto(nome: string) {
		const cores = coresDaArea(nome)
		return this.$vuetify.theme.dark ? cores.corNoEscuro : cores.cor
	}

	escolherArea(area: string | null) {
		this.area = area
	}

	limparFiltros() {
		this.busca = ''
		this.termo = ''
		this.area = null
	}

	@Watch('busca')
	aoDigitar(valor: string | null) {
		if (this.esperaDaBusca) clearTimeout(this.esperaDaBusca)
		this.esperaDaBusca = setTimeout(() => { this.termo = valor || '' }, valor ? ESPERA_DA_BUSCA : 0)
	}

	@Watch('termo')
	@Watch('area')
	guardarConsulta() {
		const consulta: Record<string, string> = {}
		if (this.termo.trim()) consulta.busca = this.termo.trim()
		if (this.area) consulta.area = this.area
		estadoDaLista.consulta = consulta
		const atual = this.$route.query
		if (atual.busca === consulta.busca && atual.area === consulta.area) return
		this.$router.replace({ query: consulta }).catch(() => undefined)
	}

	async carregar() {
		this.carregando = true
		this.erro = false
		try {
			this.atualizacoes = await buscarAtualizacoes()
		} catch (e) {
			this.erro = true
		} finally {
			this.carregando = false
		}
		this.carregarLidas()
		this.restaurarRolagem()
	}

	async carregarLidas() {
		if (!this.atualizacoes.length) return
		try {
			this.lidas = await buscarIdsLidos()
		} catch (e) {
			this.lidas = null
		}
	}

	restaurarRolagem() {
		if (!estadoDaLista.voltando) return
		estadoDaLista.voltando = false
		const rolagem = estadoDaLista.rolagem
		this.$nextTick(() => window.scrollTo(0, rolagem))
	}

	created() {
		const { busca, area } = this.$route.query
		if (typeof busca === 'string') this.busca = this.termo = busca
		if (typeof area === 'string') this.area = area
		if (this.apiConfigurada) this.carregar()
		else this.carregando = false
	}

	beforeDestroy() {
		estadoDaLista.rolagem = window.scrollY
		if (this.esperaDaBusca) clearTimeout(this.esperaDaBusca)
	}
}
